/* Nomada Climbing — interacciones 2.0 */
(function () {
  var body = document.body;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var FREE = parseInt(body.getAttribute('data-free'), 10) || 0;
  var MONEY = body.getAttribute('data-money') || '${{amount}}';
  var mobile = window.matchMedia('(max-width: 750px)');

  function fmt(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return MONEY.replace(/\{\{\s*\w+\s*\}\}/, parts.join('.'));
  }
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-count', n);
    });
  }
  var toastEl = document.querySelector('[data-toast]');
  var toastT;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.querySelector('[data-toast-text]').textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2800);
  }
  var cartTotal = null;
  function refreshCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartTotal = c.total_price; setCount(c.item_count); updateShip(); return c; })
      .catch(function () {});
  }
  function addItems(items, label) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'No se pudo agregar'); });
      return r.json();
    }).then(function () {
      toast(label + ' · agregado');
      return refreshCart();
    }).catch(function (e) { toast(e.message || 'No se pudo agregar'); });
  }

  /* encabezado */
  var hd = document.querySelector('[data-hd]');
  if (hd) {
    var menuBtn = hd.querySelector('[data-hd-menu]');
    if (menuBtn) {
      menuBtn.addEventListener('click', function () {
        var open = hd.classList.toggle('is-menu');
        menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.addEventListener('click', function (e) {
        if (hd.classList.contains('is-menu') && !hd.contains(e.target)) {
          hd.classList.remove('is-menu');
          menuBtn.setAttribute('aria-expanded', 'false');
        }
      });
    }
    document.querySelectorAll('[data-hd-search]').forEach(function (b) {
      b.addEventListener('click', function () {
        var open = hd.classList.toggle('is-search');
        if (open) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          var input = hd.querySelector('.hd__search input[type="search"]');
          if (input) setTimeout(function () { input.focus(); }, 250);
        }
        closeSheet();
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      hd.classList.remove('is-menu', 'is-search');
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
      closeSheet();
    });
  }

  /* barra inferior móvil */
  var mbar = document.querySelector('[data-mbar]');
  var sheetBtn = mbar && mbar.querySelector('[data-mbar-sheet]');
  function closeSheet() {
    if (!mbar) return;
    mbar.classList.remove('is-sheet');
    if (sheetBtn) sheetBtn.setAttribute('aria-expanded', 'false');
  }
  if (sheetBtn) {
    sheetBtn.addEventListener('click', function () {
      var open = mbar.classList.toggle('is-sheet');
      sheetBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) {
      if (mbar.classList.contains('is-sheet') && !mbar.contains(e.target)) closeSheet();
    });
  }

  /* tarjetas: agregar rápido y colores */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-qa]');
    if (qa) {
      e.preventDefault();
      qa.classList.add('is-loading');
      addItems([{ id: parseInt(qa.getAttribute('data-id'), 10), quantity: 1 }], qa.getAttribute('data-name') || 'Producto')
        .then(function () {
          qa.classList.remove('is-loading');
          qa.classList.add('is-done');
          setTimeout(function () { qa.classList.remove('is-done'); }, 1400);
        });
      return;
    }
    var sw = e.target.closest('[data-sw]');
    if (sw) {
      var card = sw.closest('[data-card]');
      card.querySelectorAll('[data-sw]').forEach(function (b) {
        var on = b === sw;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var img = card.querySelector('.card__media img');
      var src = sw.getAttribute('data-img');
      if (img && src) { img.removeAttribute('srcset'); img.src = src; }
      var lab = card.querySelector('[data-sw-label]');
      if (lab) lab.textContent = sw.getAttribute('data-label');
      card.querySelectorAll('[data-card-link]').forEach(function (a) { a.href = sw.getAttribute('data-url'); });
      var q = card.querySelector('[data-qa]');
      if (q) {
        q.setAttribute('data-id', sw.getAttribute('data-id'));
        q.setAttribute('data-name', (q.getAttribute('data-name') || '').split(' · ')[0] + ' · ' + sw.getAttribute('data-label'));
      }
    }
  });

  /* filtros de productos (inicio) */
  document.querySelectorAll('[data-pfilter]').forEach(function (bar) {
    var grid = document.getElementById(bar.getAttribute('data-pfilter'));
    if (!grid) return;
    bar.querySelectorAll('[data-cat]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cat = btn.getAttribute('data-cat');
        bar.querySelectorAll('[data-cat]').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        var shown = 0;
        grid.querySelectorAll('[data-card]').forEach(function (c) {
          var f = c.hasAttribute('data-featured');
          var ok = cat === 'todo' ? f : (!f && c.getAttribute('data-cat') === cat);
          if (ok && shown >= 8) ok = false;
          c.hidden = !ok;
          if (ok) shown++;
        });
      });
    });
  });

  /* par: selector de presentación */
  document.querySelectorAll('[data-sizes]').forEach(function (box) {
    var add = box.querySelector('[data-size-add]');
    var price = box.querySelector('[data-size-price]');
    box.querySelectorAll('[data-size]').forEach(function (b) {
      b.addEventListener('click', function () {
        box.querySelectorAll('[data-size]').forEach(function (x) {
          x.classList.toggle('is-on', x === b);
          x.setAttribute('aria-checked', x === b ? 'true' : 'false');
        });
        add.setAttribute('data-id', b.getAttribute('data-id'));
        add.setAttribute('data-name', b.getAttribute('data-name'));
        if (price) price.textContent = b.getAttribute('data-price');
      });
    });
    if (add) add.addEventListener('click', function () {
      addItems([{ id: parseInt(add.getAttribute('data-id'), 10), quantity: 1 }], add.getAttribute('data-name'));
    });
  });

  /* roster: tocar para ver perfil */
  document.querySelectorAll('[data-athlete]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      var open = !a.classList.contains('is-open');
      a.parentElement.querySelectorAll('[data-athlete].is-open').forEach(function (x) { x.classList.remove('is-open'); x.setAttribute('aria-expanded', 'false'); });
      a.classList.toggle('is-open', open);
      a.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    a.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); a.click(); }
    });
  });

  /* puntos de venta: búsqueda, región, mapa */
  document.querySelectorAll('[data-loc]').forEach(function (loc) {
    var input = loc.querySelector('[data-loc-q]');
    var items = Array.prototype.slice.call(loc.querySelectorAll('[data-loc-item]'));
    var count = loc.querySelector('[data-loc-count]');
    var empty = loc.querySelector('[data-loc-empty]');
    var frame = loc.querySelector('[data-loc-frame]');
    var region = 'todos';
    var norm = function (s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); };
    function apply() {
      var q = norm(input ? input.value.trim() : '');
      var n = 0;
      items.forEach(function (it) {
        var ok = (region === 'todos' || it.getAttribute('data-region') === region) && (!q || norm(it.getAttribute('data-text')).indexOf(q) !== -1);
        it.hidden = !ok;
        if (ok) n++;
      });
      if (count) count.textContent = n + (n === 1 ? ' punto de venta' : ' puntos de venta');
      if (empty) empty.hidden = n !== 0;
    }
    function select(it) {
      items.forEach(function (x) { x.classList.toggle('is-on', x === it); });
      if (frame) frame.src = 'https://www.google.com/maps?q=' + encodeURIComponent(it.getAttribute('data-q')) + '&output=embed';
    }
    if (input) input.addEventListener('input', apply);
    loc.querySelectorAll('[data-loc-region]').forEach(function (b) {
      b.addEventListener('click', function () {
        region = b.getAttribute('data-loc-region');
        loc.querySelectorAll('[data-loc-region]').forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        apply();
      });
    });
    items.forEach(function (it) {
      it.addEventListener('click', function (e) { if (!e.target.closest('a')) select(it); });
    });
    loc.querySelectorAll('[data-loc-view]').forEach(function (b) {
      b.addEventListener('click', function () {
        loc.setAttribute('data-view', b.getAttribute('data-loc-view'));
        loc.querySelectorAll('[data-loc-view]').forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
      });
    });
    var clear = loc.querySelector('[data-loc-clear]');
    if (clear) clear.addEventListener('click', function () { input.value = ''; apply(); input.focus(); });
    apply();
  });

  /* pie de página: acordeón en móvil */
  function syncFooter() {
    document.querySelectorAll('.ft__col').forEach(function (d) {
      if (mobile.matches) d.removeAttribute('open'); else d.setAttribute('open', '');
    });
  }
  syncFooter();
  if (mobile.addEventListener) mobile.addEventListener('change', syncFooter);
  document.querySelectorAll('.ft__col summary').forEach(function (s) {
    s.addEventListener('click', function (e) { if (!mobile.matches) e.preventDefault(); });
  });

  /* barra de envío gratis */
  function updateShip() {
    document.querySelectorAll('[data-ship]').forEach(function (el) {
      if (!FREE) { el.hidden = true; return; }
      var extra = parseInt(el.getAttribute('data-extra'), 10) || 0;
      var total = (cartTotal || 0) + extra;
      var msg = el.querySelector('[data-ship-msg]');
      var bar = el.querySelector('[data-ship-bar]');
      if (total >= FREE) {
        el.classList.add('is-free');
        msg.textContent = '¡Tienes envío gratis!';
        bar.style.width = '100%';
      } else {
        el.classList.remove('is-free');
        msg.textContent = 'Te faltan ' + fmt(FREE - total) + ' para envío gratis';
        bar.style.width = Math.round((total / FREE) * 100) + '%';
      }
    });
  }

  /* producto */
  document.querySelectorAll('[data-pd]').forEach(function (pd) {
    var json = pd.querySelector('[data-pd-variants]');
    var variants = json ? JSON.parse(json.textContent) : [];
    var form = pd.querySelector('[data-pd-form]');
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var addBtn = form.querySelector('[data-pd-add]');
    var priceEls = document.querySelectorAll('[data-pd-price]');
    var lineEls = document.querySelectorAll('[data-pd-line]');
    var stock = pd.querySelector('[data-pd-stock]');
    var ship = pd.querySelector('[data-ship]');
    var main = pd.querySelector('[data-pd-main]');
    var thumbs = Array.prototype.slice.call(pd.querySelectorAll('[data-pd-thumb]'));
    var slides = Array.prototype.slice.call(pd.querySelectorAll('[data-pd-slide]'));
    var dots = Array.prototype.slice.call(pd.querySelectorAll('[data-pd-dot]'));
    var mbuy = document.querySelector('[data-mbuy]');
    var current = variants.find(function (v) { return String(v.id) === idInput.value; }) || variants[0];
    var idx = Math.max(0, slides.findIndex(function (s) { return !s.hidden; }));

    function qty() { return Math.max(1, parseInt(qtyInput.value, 10) || 1); }
    function show(i) {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      if (mobile.matches) {
        main.scrollTo({ left: main.clientWidth * idx, behavior: 'smooth' });
      } else {
        slides.forEach(function (s, k) { s.hidden = k !== idx; });
      }
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === idx ? 'true' : 'false'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === idx); });
    }
    function syncSlides() {
      if (mobile.matches) slides.forEach(function (s) { s.hidden = false; });
      else show(idx);
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var prev = pd.querySelector('[data-pd-prev]'), next = pd.querySelector('[data-pd-next]');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
    if (main) main.addEventListener('scroll', function () {
      if (!mobile.matches) return;
      var i = Math.round(main.scrollLeft / main.clientWidth);
      if (i !== idx) { idx = i; dots.forEach(function (d, k) { d.classList.toggle('is-on', k === idx); }); }
    }, { passive: true });
    syncSlides();
    if (mobile.addEventListener) mobile.addEventListener('change', syncSlides);

    function render() {
      var q = qty();
      priceEls.forEach(function (el) { el.textContent = fmt(current.price); });
      lineEls.forEach(function (el) { el.textContent = fmt(current.price * q); });
      if (addBtn) {
        addBtn.disabled = !current.available;
        var label = addBtn.querySelector('[data-pd-label]');
        if (label) label.textContent = current.available ? 'Agregar · ' + fmt(current.price * q) : 'Agotado';
      }
      if (stock) { stock.textContent = current.available ? 'En stock' : 'Agotado'; stock.classList.toggle('is-out', !current.available); }
      if (ship) { ship.setAttribute('data-extra', current.price * q); updateShip(); }
      if (mbuy) {
        mbuy.querySelector('[data-mbuy-qty]').textContent = q;
        mbuy.querySelector('[data-mbuy-var]').textContent = current.title === 'Default Title' ? '' : current.title;
        var dot = mbuy.querySelector('[data-mbuy-dot]');
        var chk = pd.querySelector('.pd__swatches input:checked + label span');
        if (dot) { dot.style.background = chk ? chk.style.background : 'var(--sand)'; dot.hidden = !chk; }
        var mb = mbuy.querySelector('[data-mbuy-add]');
        mb.disabled = !current.available;
        mb.textContent = current.available ? 'AGREGAR' : 'AGOTADO';
      }
      pd.querySelectorAll('[data-kit-main-sub]').forEach(function (el) { el.textContent = current.title === 'Default Title' ? 'Este producto' : current.title; });
      updateKit();
    }
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-pd-opt]')) {
        var chosen = [];
        form.querySelectorAll('[data-pd-group]').forEach(function (g) {
          var c = g.querySelector('input:checked');
          chosen.push(c ? c.value : null);
          var lab = g.querySelector('[data-pd-selected]');
          if (lab && c) lab.textContent = c.value;
        });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
        if (v) {
          current = v;
          idInput.value = v.id;
          if (v.media_index > -1) show(v.media_index);
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      render();
    });
    form.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = Math.min(99, Math.max(1, qty() + parseInt(b.getAttribute('data-step'), 10)));
        render();
      });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!current.available) return;
      addBtn.disabled = true;
      addItems([{ id: current.id, quantity: qty() }], pd.getAttribute('data-title') + (current.title === 'Default Title' ? '' : ' · ' + current.title))
        .then(function () { addBtn.disabled = false; });
    });
    if (mbuy) {
      mbuy.querySelectorAll('[data-mbuy-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          qtyInput.value = Math.min(99, Math.max(1, qty() + parseInt(b.getAttribute('data-mbuy-step'), 10)));
          render();
        });
      });
      mbuy.querySelector('[data-mbuy-add]').addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }

    /* kit */
    var kit = document.querySelector('[data-kit]');
    function updateKit() {
      if (!kit) return;
      var sum = current.price;
      kit.querySelectorAll('[data-kit-item]').forEach(function (it) {
        if (it.querySelector('input').checked) sum += parseInt(it.getAttribute('data-price'), 10) || 0;
      });
      kit.querySelector('[data-kit-total]').textContent = fmt(sum);
      var s = kit.querySelector('[data-kit-ship]');
      if (s && FREE) s.textContent = sum >= FREE ? 'Incluye envío gratis' : 'Te faltan ' + fmt(FREE - sum) + ' para envío gratis';
    }
    if (kit) {
      kit.addEventListener('change', updateKit);
      kit.querySelector('[data-kit-add]').addEventListener('click', function () {
        var items = [{ id: current.id, quantity: 1 }];
        kit.querySelectorAll('[data-kit-item]').forEach(function (it) {
          if (it.querySelector('input').checked) items.push({ id: parseInt(it.getAttribute('data-id'), 10), quantity: 1 });
        });
        addItems(items, 'Kit');
      });
    }
    render();
  });

  refreshCart();
})();
